"use client";

// UNIFIED (Chris, 2026-08-11): /career-quiz always lands on the REAL quiz.
//
// History, because it explains the odd shape of this directory: the _v1
// variant was already a redirect to /career-quiz-v2, while the _v2 variant
// was a fully static PROTOTYPE (no fetch, no persistence, hardcoded demo
// data — including an invented CV filename). With REDESIGN_ALL=1 prod
// therefore served the mockup at /career-quiz one URL away from the real,
// API-backed quiz at /career-quiz-v2 — the actual root of feedback #18/#23
// ("two quizzes that look like different products"). Chris's call: unify.
// Both flag branches now redirect, so no build serves the prototype again.
// The prototype component stays on disk (_career-quiz-v2/) for reference
// only; nothing routes to it.
import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function CareerQuizPage() {
  const router = useRouter();
  useEffect(() => {
    // Preserve query params (?_redesign= debugging, UTM tags) across the hop.
    const qs = typeof window !== "undefined" ? window.location.search : "";
    router.replace(`/career-quiz-v2${qs}`);
  }, [router]);
  return null;
}
